import React, { useState } from 'react';

import { Button, Grid, Paper } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';
import HotelBiddingCriteriaManagementForm from '~/components/GoogleAdsHotelBidding/HotelBiddingCriteriaManagementForm';

interface Props {
  customerId: string;
}
export function UploadHotelBiddingCriteria({ customerId }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Paper sx={{ padding: 2 }}>
      <PageSubheader title={`Upload Criteria CSV`} />
      <Grid container spacing={2} justifyContent="start">
        <Grid item xs={3}>
          <Button variant="contained" color="primary" onClick={() => setOpen(true)} disabled={!customerId}>
            Upload Criteria
          </Button>
        </Grid>
      </Grid>
      {open && <HotelBiddingCriteriaManagementForm setOpen={setOpen} customerId={customerId} />}
    </Paper>
  );
}

export default UploadHotelBiddingCriteria;
